import { Component } from '@angular/core';

import { v4 as uuid } from 'uuid';

@Component({
  selector: 'fin-continue-reading',
  templateUrl: './continue-reading.component.html',
  styleUrls: ['./continue-reading.component.scss'],
})
export class ContinueReadingComponent {
  public readonly inputId: string = `continuereading-${uuid()}`;
}
